// String utility functions
export function removeFileNameExtension(x: string): string {
  return x.replace(/\.[^/.]+$/, '');
}

export function extractExtensionFromFileName(x: string): string | undefined {
  return x.split('.').pop();
}

export function getLengthEvery(...args: any[]): number {
  return args.reduce((acc, x) => acc + (x?.length || 0), 0);
}

// Legacy mixin format for backward compatibility (if needed)
const stringMixins = {
  methods: {
    removeFileNameExtension,
    extractExtensionFromFileName,
    getLengthEvery
  }
};

export default stringMixins;
